/* eslint-disable no-return-await */
/* eslint-disable no-shadow */
import React, { useEffect, useState } from 'react'
import TotalEnduroPage from 'src/pages/ReportsPages/ReportsBoard/MarketShareReportsPages/TotalEnduroPage'
import boardReportsService from 'src/services/boardReportsService'

const MarkertEnduroCompany = () => {
  const [selectedDate, setSelectedDate] = useState(new Date())
  const [totalEnduro, setTotalEnduro] = useState([])
  const [totalEnduroSegment, setTotalEnduroSegment] = useState([])
  const [gTotalEnduroA, setGTotalEnduroA] = useState([])
  const [gTotalEnduroB, setGTotalEnduroB] = useState([])

  const handleDateChange = value => {
    setSelectedDate(value)
  }

  const reloadComponents = async () => {
    const [
      totalEnduro,
      totalEnduroSegment,
      gTotalEnduroA,
      gTotalEnduroB,
    ] = await Promise.all([
      boardReportsService.getTotalMarketShare('3', selectedDate.getFullYear(), 'subcategoria=ENDURO'),
      boardReportsService.getTotalMarketShare('4', selectedDate.getFullYear(), 'subcategoria=ENDURO'),
      boardReportsService.getTotalMarketShareGraphics('4a', selectedDate.getFullYear(), 'subcategoria=ENDURO'),
      boardReportsService.getTotalMarketShareGraphics('4b', selectedDate.getFullYear(), 'subcategoria=ENDURO'),
    ])
    setTotalEnduro(totalEnduro)
    setTotalEnduroSegment(totalEnduroSegment)
    setGTotalEnduroA(gTotalEnduroA)
    setGTotalEnduroB(gTotalEnduroB)
  }

  useEffect(() => {
    reloadComponents()
  }, [selectedDate])


  return (
    <TotalEnduroPage
      handleDateChange={handleDateChange}
      selectedDate={selectedDate}
      totalEnduro={totalEnduro}
      totalEnduroSegment={totalEnduroSegment}
      gTotalEnduroA={gTotalEnduroA}
      gTotalEnduroB={gTotalEnduroB}
    />
  )
}

export default MarkertEnduroCompany
